import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Observer} from "rxjs";
import {StartupHttpService} from "../http/startup.http.service";
import {BootGlobals} from "../../boot.globals";
import {Login} from "../../login/login";
import {ModalConfig} from "../notification/modal.config";
import {APIResult} from "../interaction/upload.service";

@Injectable()
export class Authenticator {

    constructor(private http: StartupHttpService,
                private loginService: Login,
                private modalConfig: ModalConfig) {
    }

    public authenticate(): Observable<any> {
        return new Observable((observer: Observer<any>) => {
          this.clearPersistedLoginData();
            this.login().subscribe(() => {
                observer.next("");
                observer.complete();
            });
        });
    }

    private login(): Observable<string> {
      let url =
            BootGlobals.config.isSuperUserMode ?
                "resources/superuser/authentication.json" :
                BootGlobals.config.credentialsPath;

        console.log("Logging into slc with credentials to ", url);

        return new Observable((observer: Observer<any>) => {
            this.http.getWithReferrer(url,
                (data: APIResult) => {
                    if (data.data === "") {
                        // can't put up a modal because we haven't loaded the main app yet
                        window.close();
                    } else {
                        console.log("User is authenticated.");
                        this.success(data.data as string);
                        observer.next("");
                        observer.complete();
                    }
                },
                (error) => {
                    // can't put up a modal because we haven't loaded the main app yet
                    window.close();
                });
        });
    }

    private success(result: string): void {
        let data = JSON.parse(result);
        this.loginService.name = data.authenticationInfo.learner.name,
        this.loginService.learnerId = data.authenticationInfo.learner.id,
        this.loginService.sessionId = data.authenticationInfo.sessionId,
        this.loginService.tenantId = data.authenticationInfo.learner.org.tenantId;
    }

    private clearPersistedLoginData(): void {
        // TODO:  why do we do this?  maybe because exit isn't implemented?
        window.localStorage.removeItem("learnerId");
        window.localStorage.removeItem("sessionId");
    }
}
